@if (component.data$ | async; as data) {
<div
  class="responsive-banner-container display-none"
  [class.hasTitle]="responsiveBannerTitle"
  [class.display-block]="
    leftImagePages.includes(requestAccount(data['styleClass'])) ||
    (isCurrentPage$ | async)
  " 
>
  @if (isDesktop && data.media) {
  <cx-media
    [container]="data?.media['desktop']"
    [class.hasTitle]="responsiveBannerTitle"
    class="responsive-desktop"
    [ngClass]="activeCountry$ | async"
    removeImageTitleAttr
  ></cx-media>
  } @if (!isDesktop && !isMobile && data.media) {
  <cx-media
    [container]="data?.media['tablet']"
    [class.hasTitle]="responsiveBannerTitle"
    [ngClass]="linesOfBannerName()"
    class="responsive-tablet"
    [ngClass]="activeCountry$ | async"
    removeImageTitleAttr
  ></cx-media>
  } @if (isMobile && data.media) {
  <cx-media
    [container]="data?.media['mobile']"
    [class.hasTitle]="responsiveBannerTitle"
    class="responsive-mobile"
    [ngClass]="linesOfBannerName()"
    [ngClass]="activeCountry$ | async"
    removeImageTitleAttr
  ></cx-media>
  } @if (responsiveBannerTitle) {
  <div
    class="d-flex align-self-center text"
    [class.pos-rel]="
      !((isDesktop && data.media) || (!isDesktop && !isMobile && data.media) || (isMobile && data.media))
    "
  >
    @if ((responsiveBannerTitle | json) != '{}') {
    <h1>{{ responsiveBannerTitle }}</h1>
    }
  </div>
  }
</div>
} @if (myaccount) {
<div class="myaccount-banner-info">
  <div class="myaccount-title">
    <p id="banner" class="myaccount-banner-name">
      {{ myaccount?.name }}
    </p>
  </div>
  <div class="main-wrapper">
    <div class="myaccount-banner-content">
      <div class="myaccount-customer-service">
        <p class="myaccount-label">{{ myaccount.customerNumberLabel }}</p>
        <p class="myaccount-info">{{ myaccount?.uid }}</p>
      </div>
      @if (showVatNumber$ | async) {
      <div class="myaccount-customer-registration">
        <p class="myaccount-label">
          {{ myaccount.customerRegistrationNumberLabel }}
        </p>
        <p class="myaccount-info">{{ myaccount?.ilnID }}</p>
      </div>
      }
    </div>
    <div class="myaccount-banner-dealership">
      <p class="myaccount-label">{{ myaccount.dealershipTypeLabel }}</p>
      <p class="myaccount-dealership">
        @for (dealership of myaccount.dealershipTypes.enums; track dealership; let last = $last) {
        <span class="myaccount-info">
          @if (!last) {
          {{ dealership?.name }}, } @else {
          {{ dealership?.name }}
          }
        </span>
        }
      </p>
    </div>
  </div>
</div>
}
